import { useMutation, useQueryClient } from 'react-query';

import { signPeriodReportByPestEmployeePost as sign } from 'api/periodReports/signPeriodReportByPestEmployeePorst';

const useSignPeriodReportByEmployee = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: signPeriodReportByEmployee,
    isLoading,
  } = useMutation(sign, {
    onSuccess: () => {
      queryClient.invalidateQueries('periodDocs');
    },
  });

  return { isSuccess, signPeriodReportByEmployee, isLoading };
};

export default useSignPeriodReportByEmployee;
